import * as React from 'react';

import { ModalFrame, ModalFrameMessage } from 'components/modal';

type Props = {
  title: string,
  message: string
};

class SubscriptionModal extends React.PureComponent<Props> {
  // this component will be bigger with time, that's why it is really simple right now
  render() {
    const { title, message } = this.props;

    return (
      <ModalFrame
        title={title}
      >
        <ModalFrameMessage
          message={message}
        />
      </ModalFrame>
    );
  }
}

export default SubscriptionModal;
